/**
 * @typedef {Object} ET.FeedObject
 * @property {string} type
 * @property {number} id
 * @property {string} code
 */

/**
 * @typedef {Object} ET.Feed
 *
 * @property {string} type
 * @property {string} algorithm
 * @property {number} position
 * @property {number} id based on code?
 * @property {string} code
 * @property {string} [title='']
 * @property {[ET.FeedObject]}  objects_extends
 */

/**
 * It should accept emoji icons array and produce ET feed according to rules described in file
 * @see {@link file://ET.md ET.md}
 * @return {ET.Feed}
 */
export function createFeed(pack, icons) {
  const objects_extended = icons.map((icon) => ({
    type: 'emoji',
    id: icon.id,
    code: icon.name,
  }));

  return {
    type: 'emoji_panel',
    algorithm: 'interactive',
    position: 1,

    id: pack.id ?? 0,
    title: pack.name ?? '',
    objects_extended,
  };
}
